// ContractsTab.tsx
import { Button } from "@racoon/ui";
import { useT, Namespace } from "@racoon/i18n";
import { ConnectProto } from "@racoon/api";
import { ContractItem } from "./contract-row.content";
import { EmptyState } from "../EmptyState";
import { IcPlus } from "@racoon/icons";

interface ContractsTabProps {
  contracts?: ConnectProto.Contract[];
  loading: boolean;
  onAddContract: () => void;
  onEditContract?: (contract: ConnectProto.Contract) => void;
}

export const ContractsTab: React.FC<ContractsTabProps> = ({
  contracts,
  loading,
  onAddContract,
  onEditContract,
}) => {
  const t = useT();

  return (
    <div className="space-y-4">
      <Button
        id="contracts-tab-add-button"
        className="w-full flex items-center !bg-white"
        onClick={onAddContract}
        variant="opacityBlueWithOutline"
      >
        <IcPlus className="h-6 w-6" />
        {t(Namespace.Customers, "card.contracts.add")}
      </Button>

      <div className="max-h-96 flex-1 overflow-y-auto space-y-3">
        {loading ? (
          <div className="flex justify-center items-center h-32">
            <span className="text-gray-400">{t(Namespace.Common, "loading")}</span>
          </div>
        ) : contracts && contracts.length > 0 ? (
          <div className="flex flex-col gap-2">
            {contracts
              .filter((contract) => contract.status !== ConnectProto.ContractStatus.HIDDEN)
              .map((contract) => (
                <ContractItem
                  key={contract.id}
                  contract={contract}
                  onEditContract={onEditContract}
                />
              ))}
          </div>
        ) : (
          <EmptyState />
        )}
      </div>
    </div>
  );
};
